import { applyMiddleware, createStore, Reducer, Store as ReduxStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunk from 'redux-thunk';

export class Store {

  static store: ReduxStore;

  static initiate(reducers: Reducer) {
    if (Store.store) { throw new Error('store is already initialized'); }
    return (Store.store = createStore(reducers, composeWithDevTools(applyMiddleware(thunk))));
  }

  static getInstance() {
    if (!Store.store) { throw new Error('store is not initialized'); }
    return Store.store;
  }
  constructor() {
    throw new Error('Store is not an instanciable class');
  }
}
